import React from 'react';
import { connect } from 'react-redux';
import { SpecTestsCustomPanel } from './SpecTestsCustomPanel';
import { SpecTestsNoSideCommentPanel } from './SpecTestsNoSideCommentPanel';
import { SpecTestsNoSidePosNegPanel } from './SpecTestsNoSidePosNegPanel';
import { SpecTestsNoSidePresentAbsentPanel } from './SpecTestsNoSidePresentAbsentPanel';
import { SpecTestsNoSideYesNoPanel } from './SpecTestsNoSideYesNoPanel';
import { SpecTestsRLCommentPanel } from './SpecTestsRLCommentPanel';
import { SpecTestsRLDTRPanel } from './SpecTestsRLDTRPanel';
import { SpecTestsRLPosNegPanel } from './SpecTestsRLPosNegPanel';
import { SpecTestsRLPresentAbsentPanel } from './SpecTestsRLPresentAbsentPanel';

class PatientCareCenterNoteObjectiveSpecTestsPanel extends React.Component {

    render() {
        switch (this.props.panelType) {
            case 3:
                return (
                    <SpecTestsCustomPanel panelId={this.props.panelId} includeFlags={this.props.includeFlags} header={this.props.header} />
                );
            case 4:
                return (
                    <SpecTestsNoSidePosNegPanel panelId={this.props.panelId} includeFlags={this.props.includeFlags} header={this.props.header} />
                );
            case 5:
                return (
                    <SpecTestsRLPosNegPanel panelId={this.props.panelId} includeFlags={this.props.includeFlags} header={this.props.header} />
                );
            case 6:
                return (
                    <SpecTestsNoSideYesNoPanel panelId={this.props.panelId} includeFlags={this.props.includeFlags} header={this.props.header} />
                );
            case 7:
                return (
                    <SpecTestsNoSidePresentAbsentPanel panelId={this.props.panelId} includeFlags={this.props.includeFlags} header={this.props.header} />
                );
            case 8:
                return (
                    <SpecTestsRLPresentAbsentPanel panelId={this.props.panelId} includeFlags={this.props.includeFlags} header={this.props.header} />
                );
            case 9:
                return (
                    <SpecTestsRLDTRPanel panelId={this.props.panelId} includeFlags={this.props.includeFlags} header={this.props.header} />
                );
            case 10:
                return (
                    <SpecTestsNoSideCommentPanel panelId={this.props.panelId} includeFlags={this.props.includeFlags} header={this.props.header} />
                );
            case 11:
                return (
                    <SpecTestsRLCommentPanel panelId={this.props.panelId} includeFlags={this.props.includeFlags} header={this.props.header} />
                );
            case 14:
                return (
                    <SpecTestsNoSidePosNegPanel panelId={this.props.panelId} includeFlags={this.props.includeFlags} header={this.props.header} reverseFlag={true} />
                );
            case 15:
                return (
                    <SpecTestsRLPosNegPanel panelId={this.props.panelId} includeFlags={this.props.includeFlags} header={this.props.header} reverseFlag={true} />
                );
            default:
                return (
                    <span />
                );
        }
    }
}

function mapStateToProps(state, ownprops) {
    return {
        panelType: state.entities.masterData.PTMASTEROBJECTIVEPANELS[ownprops.panelId].MOPMPTNO
    };
}

const connectedPatientCareCenterNoteObjectiveSpecTestsPanel = connect(mapStateToProps)(PatientCareCenterNoteObjectiveSpecTestsPanel);
export { connectedPatientCareCenterNoteObjectiveSpecTestsPanel as PatientCareCenterNoteObjectiveSpecTestsPanel };


